<div class="flex flex-col gap-0.5">
    <div
        class="flex flex-col gap-2 items-baseline"
        [class.opacity-50]="disabled()">
        @if (label()) {
            <label
                class="font-normal text-base"
                [for]="inputId"
                [matTooltip]="labelTooltip()"
                [matTooltipDisabled]="!labelTooltip()"
                >{{ label() }}</label
            >
        }

        @if (errors().length) {
            @for (error of errors(); track error) {
                <span class="text-error text-xs">
                    {{ error | transloco }}
                </span>
            }
        }
    </div>

    @if (inputFormControl()) {
        <input
            class="!rounded-lg"
            type="number"
            [class]="additionalClasses()"
            [class.border-error]="errors().length"
            [class.border-none]="!errors().length"
            [class.disabled]="disabled()"
            [formControl]="inputFormControl()!"
            [id]="inputId"
            [matTooltip]="valueTooltip()"
            [matTooltipDisabled]="!valueTooltip()"
            [max]="max()"
            [min]="min()"
            [placeholder]="placeholder() ?? '0'"
            (blur)="handleOnBlur()"
            (change)="handleOnBlur()"
            (input)="onChange($event)" />
        @if (!!inputFormControl()!.errors && !errors().length) {
            @for (error of inputFormControl()!.errors | keyvalue; track error) {
                <mat-error class="!text-error">{{ formService.getErrorMessage(error) }}</mat-error>
            }
        }
    } @else {
        <input
            class="!rounded-lg"
            type="number"
            [class]="additionalClasses()"
            [class.border-error]="errors().length"
            [class.border-none]="!errors().length"
            [class.disabled]="disabled()"
            [disabled]="disabled()"
            [id]="inputId"
            [matTooltip]="valueTooltip()"
            [matTooltipDisabled]="!valueTooltip()"
            [max]="max()"
            [min]="min()"
            [placeholder]="placeholder() ?? '0'"
            (blur)="handleOnBlur()"
            (change)="handleOnBlur()"
            (input)="onChange($event)" />
    }
</div>
